import { z } from "zod";

export const schema = z
    .object({
        ativo: z.boolean(),
        token: z.string().min(1, "Token é obrigatório"),
        descricao: z.string().min(1, "Descrição é obrigatória").max(255, "Certifique-se de que este campo não tenha mais de 255 caracteres"),
        local_atendimento: z.string().min(1, "Local de atendimento é obrigatório"),
        orgao: z.string().min(1, "Órgão é obrigatório"),
        servicos: z.array(z.string()).min(1, "Selecione pelo menos um serviço"),
        prioridades: z.array(z.string()).min(1, "Selecione pelo menos uma prioridade"),
        senha_reset: z.string().min(1, "Senha de reset é obrigatória"),
        cor_fonte: z.string()
            .min(1, "Cor da fonte é obrigatória")
            .max(7, "Certifique-se de que este campo não tenha mais de 7 caracteres")
            .regex(/^#[0-9A-Fa-f]{6}$/, "Informe um código de cor hexadecimal válido"),
        cor_fundo: z.string()
            .min(1, "Cor de fundo é obrigatória")
            .max(7, "Certifique-se de que este campo não tenha mais de 7 caracteres")
            .regex(/^#[0-9A-Fa-f]{6}$/, "Informe um código de cor hexadecimal válido"),
        logo: z.instanceof(File, {
            message: "Arquivo de logo é obrigatório",
        })
            .refine(file => {
                const allowedTypes: { [key: string]: boolean } = {
                    "image/png": true,
                };
                return allowedTypes[file.type];
            }, { message: "Apenas arquivos PNG são permitidos" })
            .refine(file => file.size <= 1 * 1024 * 1024, {
                message: "O arquivo deve ter no máximo 1MB",
            })
            .refine(
                file =>
                    new Promise<boolean>(resolve => {
                        const img = new Image();
                        img.onload = () => {
                            resolve(
                                img.width <= 240 &&
                                img.height <= 240
                            );
                        };
                        img.onerror = () => resolve(false);
                        img.src = URL.createObjectURL(file);
                    }),
                {
                    message: "A resolução deve ser no máximo 240x240 pixels",
                }
            )
            .or(z.string()),
    });
